<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.4)"
  size="medium"
  color="#EB0045"
  type="ball-spin-clockwise-fade"
  [fullScreen]="true"
></ngx-spinner>
<router-outlet></router-outlet>
